import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'

const useEksPcsDetailsQuery = () => {
  const { stationCode, blockIndex, eksPcsGroupId } = useParams()
  const { session } = useContext(SessionContext)

  return useQuery(
    ['eksPcsDetails', stationCode, blockIndex, eksPcsGroupId],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }
      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/pcsgroups/${eksPcsGroupId}/status`,
        axiosOptions,
      )
      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useEksPcsDetailsQuery
